export default "__VITE_ASSET__C_Jeim7p__"